<template>
  <turnos />
</template>

<script>
/* eslint-disable */
import Turnos from "@/components/Turnos";
import { mapActions } from "vuex";

export default {
  name: "Home",

  components: {
    Turnos,
  },
  methods: {
    ...mapActions("parametro", ["fetchListaPacientes"]),
  },
  async created() {
    while (!this.isRestored) {
      await this.$sleep(10)
    }
    await this.fetchListaPacientes();
  },
};
</script>
